import script from "./ProductTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTable.vue?vue&type=script&lang=ts&setup=true"

import "./ProductTable.vue?vue&type=style&index=0&id=fd1c118a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd1c118a"]])

export default __exports__